/**
 * RoadmapCommentReply Remapper
 * Flutter source: lib/data/models/roadmap_comment_reply.dart (+ .g.dart)
 */

import type { RoadmapCommentReplyDto } from '@/data/dtos/roadmapComment/roadmapCommentReplyDto';
import type { JsonObject } from '@/data/types/json';
import type { RoadmapCommentReplyEntity } from '@/domain/entities/roadmapComment/roadmapCommentReplyEntity';

export class RoadmapCommentReplyRemapper {
  static fromJson(data: JsonObject): RoadmapCommentReplyDto {
    return {
      replyId: (data['replyId'] as string | undefined) || '',
      userName: (data['userName'] as string | undefined) || '',
      userId: (data['userId'] as string | undefined) || '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): RoadmapCommentReplyDto[] {
    return dataList.map(RoadmapCommentReplyRemapper.fromJson);
  }

  static toEntity(dto: RoadmapCommentReplyDto): RoadmapCommentReplyEntity {
    return { ...dto };
  }

  static toDto(entity: RoadmapCommentReplyEntity): RoadmapCommentReplyDto {
    return { ...entity };
  }

  static toJson(dto: RoadmapCommentReplyDto): JsonObject {
    return {
      replyId: dto.replyId,
      userName: dto.userName,
      userId: dto.userId,
    };
  }
}
